/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IWorkflowConfigurationScope extends angular.IScope {
        model: models.WorkflowConfigurationModel
    }

    export class WorkflowConfigurationController implements IController {
        constructor(
            private scope: IWorkflowConfigurationScope,
            $timeout: ng.ITimeoutService,
            $routeParams: angular.route.IRouteParamsService,
            workflowService: services.WorkflowService,
            deleteService: services.DeleteService,
            workflowDrawingService: services.WorkflowDrawingService,
            modalService: any)
        {
            var processConfigId = $routeParams["id"];

            this.scope.model = new models.WorkflowConfigurationModel(
                scope,
                $timeout,
                processConfigId,
                models.WorkflowMode.Workflow,
                workflowService,
                deleteService,
                workflowDrawingService,
                modalService);
        }
    }
}

warsApp.registerController('WorkflowConfigurationController', ['$scope', '$timeout', '$routeParams', 'workflowService', 'deleteService', 'workflowDrawingService', 'ModalService']);